import { LocalStorageContextDefaultValues, User, useLocalStorageContext } from "../Provider/LocalStorageProvider";
import { CommonService } from "../services/Common/CommonService";
import { appInsights } from "../services/Logging/AppInsights";

export const getUserRoles = (isUserSignedIn: boolean, setUser: React.Dispatch<React.SetStateAction<User>>) => {
  //const { isUserSignedIn, setUser } = useLocalStorageContext();
  if (isUserSignedIn) {
    CommonService.getUserRoles()
      .then((response) => {
        if (
          response?.data?.data?.role === null ||
          response?.data?.data?.role === undefined
        ) {
          setUser((previousUser) => ({
            ...previousUser,
            ...previousUser,
            ...LocalStorageContextDefaultValues,
            isUserSignedIn,
          }));
        } else {
          const { role, regions } = response?.data?.data;
          setUser((previousUser) => ({
            ...previousUser,
            isUserSignedIn: isUserSignedIn,
            isUserAuthorized: true,
            userRole: role,
            userRegions: regions,
            genericRole: role < 4 || role === 6 ? role : -1,
          }));
        }
      })
      .catch((error) => {
        setUser((previousUser) => ({
          ...previousUser,
          ...LocalStorageContextDefaultValues,
          isUserSignedIn,
        }));
        appInsights.trackException({
          error: new Error(error as string),
          properties: {
            name: "In UserAuthorization.ts, Error in GetUserRoles API",
          },
        });
        console.log("Error in GetUserRoles API:", error);
      });
  } else {
    // setUser(() => ({
    //     ...LocalStorageContextDefaultValues
    // }))
    setUser({...LocalStorageContextDefaultValues})
  }
};
